import Login from './Modules/login';

const Modules = {
  Login
};

export default Modules;
